export default __webpack_public_path__ + "static/media/memory.6c1d7584.png";